import { Token } from "@/models/auth/token"
import Repository from './Repository'
import { AxiosResponse } from 'axios'
import { Login } from "@/models/auth/login"

const resource = '/auth'

class AuthRepository {
    auth(login: Login): Promise<AxiosResponse<Token>> {
        return Repository.post<Token>(`${resource}/admin`, login)
    }

    authGoogle(googleLogin: Token): Promise<AxiosResponse<Token>> {
        return Repository.post<Token>(`${resource}/google`, googleLogin)
    }
}

export default new AuthRepository()